import { InjectionToken } from '@angular/core';

export const IMAGE_ORIGIN = new InjectionToken<string>('IRD_IMAGE_ORIGIN', {
  providedIn: 'root',
  factory: () => '',
});
